import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PlaceTradeCommUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.placeTradeComm(req);
    }
}
export default PlaceTradeCommUseCase;
